import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, WalletFilledIcon } from '@blade/ui-kit'

import { walletsManagerModelAtom } from '../../atoms'

import { WalletsHeaderSummary } from './wallets-header-summary'

type WalletsHeaderProps = {}

export const WalletsHeader: React.FC<WalletsHeaderProps> = () => {
  const { t } = useTranslation()

  const [model] = useAtom(walletsManagerModelAtom)
  const [screen, setScreen] = useAtom(model.walletDetailsScreen)

  return (
    <Root>
      <WalletsHeaderSummary />
      <Actions>
        <Button
          size="h32"
          radius="rounded"
          variant="secondary"
          iconLeft={<WalletFilledIcon />}
          data-active={screen === 'import-wallet'}
          onClick={() => setScreen('import-wallet')}
        >
          {t('wallet.import_wallet')}
        </Button>
        <Button
          size="h32"
          radius="rounded"
          variant="solid"
          color="primary"
          iconLeft={<WalletFilledIcon />}
          data-active={screen === 'new-wallet'}
          onClick={() => setScreen('new-wallet')}
        >
          {t('wallet.create.create-new-wallet')}
        </Button>
      </Actions>
    </Root>
  )
}

const Root = styled.div`
  padding-inline: 10px;
  padding-block: 10px;
  border-bottom: 1px solid var(--background-3);

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;
`

const Actions = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 12px;
`
